<template>
    <div class="lx-page" :style="{ height: `calc(100% - ${offsetTop}px)` }">
        <busy-modal :show="busy"></busy-modal>
        <span v-if="tabs.length">
            <b-row class="nav-tabs-row no-gutters">
                <b-col md="12" lg="12" xl="12">
                    <b-nav tabs :class="{ 'd-none': !showNav, 'm-1': regularTabs, 'mt-2': regularTabs }">
                        <b-nav-item
                            :class="{ 'd-none d-md-flex d-sm-flex': isMobileTabVersion }"
                            v-for="(tab, index) in tabs"
                            :key="'page-tab-' + index"
                            :to="tab.route"
                            :active="tab.active || null"
                            :disabled="tab.disabled || false"
                            @click="() => tab.callback && tab.callback(tab.title, index)"
                        >
                            <div :style="{ display: 'inline-block' }">
                                <div class="tab-title-wrapper">
                                    <b-form-input
                                        v-if="canEditTabTitle"
                                        class="tab-title-input"
                                        v-model="tab.title"
                                        @update="() => onEditTabTitle(tab)"
                                        size="sm"
                                    ></b-form-input>
                                    <span v-else>
                                        <img
                                            v-if="tab.titleIcon && !tab.titleIcon.hide"
                                            class="title-icon"
                                            :title="tab.titleIcon.title"
                                            :src="tab.titleIcon.src"
                                            :class="tab.titleIcon.class"
                                        />
                                        {{ tab.title }}
                                    </span>
                                    <div :id="'copy-url' + tab.id" v-if="canCopy" @click="copyCallback(tab.currentUrl)">
                                        <font-awesome-icon icon="copy" class="copy-button ml-1" />
                                    </div>
                                    <b-tooltip
                                        v-if="canCopy"
                                        :target="'copy-url' + tab.id"
                                        :title="tab.currentUrl"
                                        variant="info"
                                        container="vue-app"
                                        :placement="'auto'"
                                        noninteractive
                                    />
                                </div>
                                <div class="remove-tab-wrapper" v-if="canRemoveTab">
                                    <span @click="() => onRemoveTab(tab)" class="d-flex">
                                        <font-awesome-icon  size="sm" :icon="['fas', 'xmark']"></font-awesome-icon>
                                    </span>
                                </div>
                            </div>
                            <!-- <span>{{ tab.title }}</span> -->
                        </b-nav-item>
                        <b-nav-item-dropdown v-if="isMobileTabVersion" :text="activeTabTitle" class="d-block d-sm-none">
                            <template v-if="activeTabIcon" slot="button-content">
                                <img class="title-icon" :title="activeTabIcon.title" :src="activeTabIcon.src" />
                                {{ activeTabTitle }}
                            </template>
                            <b-dropdown-item
                                v-for="(tab, index) in tabs"
                                :key="index"
                                :to="tab.route"
                                :disabled="tab.disabled || false"
                                @click.stop="() => tab.callback && tab.callback(tab.title, index)"
                            >
                                <div class="d-flex flex-nowrap">
                                    <span>
                                        <img
                                            v-if="tab.titleIcon"
                                            class="title-icon"
                                            :title="tab.titleIcon.title"
                                            :src="tab.titleIcon.src"
                                        />
                                        {{ tab.title }}
                                    </span>
                                    <div
                                        :id="'copy-url' + tab.id"
                                        v-if="canCopy"
                                        @click="$emit('copy-url', tab.currentUrl)"
                                    >
                                        <font-awesome-icon icon="copy" class="copy-button ml-1" />
                                    </div>
                                </div>
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-form v-if="canAddTab" @submit.prevent="onAddTab" class="ml-1">
                            <b-button type="submit" variant="link">
                                <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
                            </b-button>
                        </b-nav-form>
                        <div class="d-flex ml-auto">
                            <b-nav-item
                                v-if="rightButton != null && rightButton.visible()"
                                class="nav-right-button"
                                @click="rightButton.callback"
                            >
                                <b-button
                                    :variant="rightButton.variant"
                                    :class="[
                                        'right-button',
                                        rightButton.bold ? 'font-weight-bold' : '',
                                        !rightButton.text ? 'icon-only' : '',
                                    ]"
                                    @click="rightButton.callback"
                                    size="md"
                                    >{{ rightButton.text }}
                                    <font-awesome-icon
                                        v-if="rightButton.icon"
                                        :class="[rightButton.text ? 'ml-2' : '']"
                                        :icon="getIcon()"
                                        :rotation="rightButton.rotation || null"
                                    ></font-awesome-icon>
                                </b-button>
                            </b-nav-item>
                            <b-nav-item
                                v-if="rightButton2 != null && rightButton2.visible()"
                                class="nav-right-button"
                                @click="rightButton2.callback"
                            >
                                <b-button
                                    :variant="rightButton2.variant"
                                    :class="[
                                        'right-button',
                                        rightButton2.bold ? 'font-weight-bold' : '',
                                        !rightButton2.text ? 'icon-only' : '',
                                    ]"
                                    @click="rightButton2.callback"
                                    size="md"
                                    >{{ rightButton2.text }}
                                    <font-awesome-icon
                                        v-if="rightButton2.icon"
                                        :class="[rightButton2.text ? 'ml-2' : '']"
                                        :icon="getIcon2()"
                                        :rotation="rightButton2.rotation || null"
                                    ></font-awesome-icon>
                                </b-button>
                            </b-nav-item>
                        </div>
                    </b-nav>
                </b-col>
            </b-row>
        </span>
        <span v-else-if="canAddTab">
            <b-nav tabs :class="{ 'd-none': !showNav, 'm-1': regularTabs, 'mt-2': regularTabs }">
                <b-nav-form @submit.prevent="onAddTab" class="ml-1">
                    <b-button type="submit" variant="link">
                        <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
                    </b-button>
                </b-nav-form>
            </b-nav>
        </span>
        <div
            ref="pageContainer"
            class="lx-page-container"
            :style="{ height: `calc(100% - ${pageContainerOffsetTop}px)` }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import BusyModal from '../busy-modal/busy-modal.vue';
    import debounce from 'lodash/debounce';
    import { setPageTitle } from '../../../utils/api';

    export default {
        name: 'Page',
        components: {
            BusyModal,
        },
        props: {
            tabs: {
                type: Array,
                default: () => [],
            },
            canAddTab: {
                type: Boolean,
                default: false,
            },
            canEditTabTitle: {
                type: Boolean,
                default: false,
            },
            canRemoveTab: {
                type: Boolean,
                default: false,
            },
            busy: {
                type: Boolean,
                default: false,
            },
            compactMobileView: {
                type: Boolean,
                default: true,
            },
            showNav: {
                type: Boolean,
                default: true,
            },
            canCopy: {
                type: Boolean,
                default: false,
            },
            regularTabs: {
                type: Boolean,
                default: true,
            },
            rightButton: {
                type: Object,
                default: null,
            },
            rightButton2: {
                type: Object,
                default: null,
            },
        },
        data: function () {
            return {
                el: null,
                pageContainerEl: null,
                offsetTop: 0,
                pageContainerOffsetTop: 0,
            };
        },
        provide() {
            return {
                showSuccessToast: this.showSuccessToast,
                showErrorToast: this.showErrorToast,
            };
        },
        computed: {
            activeTabTitle() {
                const active = this.tabs.find((i) => i.active);
                return active ? active.title : '';
            },
            activeTabIcon() {
                const active = this.tabs.find((i) => i.active);
                return active ? active.titleIcon : null;
            },
            isMobileTabVersion() {
                return this.compactMobileView && this.tabs && this.tabs.length > 2;
            },
        },
        mounted: function () {
            this.$nextTick(() => {
                this.el = this.$el;
                this.pageContainerEl = this.$refs.pageContainer;
                this.setOffsetTop();
                window.addEventListener('resize', this.setOffsetTop);
            });
            setPageTitle(this.$route.name);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.setOffsetTop);
        },
        methods: {
            setOffsetTop() {
                this.offsetTop = this.el.offsetTop;
                this.pageContainerOffsetTop = this.pageContainerEl.offsetTop;
            },
            onAddTab() {
                this.$emit('add-tab');
            },
            onEditTabTitle: debounce(function (tab) {
                this.$emit('update-tab-title', tab);
            }, 1000),
            onRemoveTab(tab) {
                this.$emit('remove-tab', tab);
            },
            getIcon() {
                return ['fas', this.rightButton.icon];
            },
            getIcon2() {
                return ['fas', this.rightButton2.icon];
            },
            showSuccessToast({ text, title = 'Success!' }) {
                this.successToast({ text: text, title: title });
            },
            showErrorToast({ text, title = 'Error!', autoHideDelay = 5000 }) {
                this.errorToast({ text: text, title: title, autoHideDelay: autoHideDelay });
            },
            copyCallback(value) {
                this.$emit('copy-url', value);
            },
        },
        watch: {
            $route() {
                setPageTitle(this.$route.name);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    :deep(.main-message-bar) {
        border-radius: 0 !important;
        margin-bottom: 0 !important;
    }

    .lx-page {
        position: relative;
    }

    @media print {
        .lx-page {
            position: static;
        }
    }

    .btn:focus {
        outline: none;
        box-shadow: none !important;
    }

    .tab-title-wrapper {
        float: left;
        display: flex;
    }

    .tab-title-input {
        width: 130px !important;
    }

    .remove-tab-wrapper {
        cursor: pointer;
        color: rgba(50, 50, 50, 0.5);
        float: right;
        position: relative;
        left: 11px;
        bottom: 5px;

        &:hover {
            color: rgba(50, 50, 50);
        }
    }

    .lx-page-container {
        position: relative;
        overflow: auto;
    }

    @media print {
        .lx-page-container {
            position: static;
            height: auto !important;
            width: auto !important;
        }
    }

    .title-icon {
        width: 25px;
        height: 25px;
        margin-right: 0.3rem;
    }

    .copy-button {
        cursor: pointer;
        font-weight: normal;
        color: #6c757d;
        transition: 0.3s color;
        &:hover {
            color: #cdcdcd;
        }
    }
    .vue-app-wrapper .dropdown-item {
        display: flex !important;
        flex-wrap: nowrap !important;
    }
    .nav-right-button {
        padding: 0.3rem 1rem 0.5rem 0;
        :deep(.nav-link) {
            padding: 0 !important;
        }
    }
    :deep(.right-button) {
        align-items: center;
        justify-content: center;
        display: inline-flex !important;
        line-height: 21px !important;
    }

    :deep(.icon-only) {
        font-size: 20px !important;
    }

    :deep(.nav-tabs-row) {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    @include media-breakpoint-down(md) {
        :deep(.right-button) {
            display: none !important;
        }
    }
</style>
